import React from "react";
import { Col, Row } from "react-bootstrap";
import { isRgbColorEnabled, getScaleColors } from "../../../../../../../Helpers/RgbColorHelper";

export default function Summary_L_Bar({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Check if RGB color is enabled using helper
  const rgbEnabled = isRgbColorEnabled(item.scale);

  // Get color variations using helper only if RGB is enabled
  const colors = rgbEnabled ? getScaleColors(item.scale) : null;

  // Default colors
  const progressColor = rgbEnabled ? colors.primary : "#4a90e2";
  const backgroundColor = rgbEnabled ? colors.light : "#e0e0e0";

  return (
    <Row style={{ paddingTop: "20px", paddingBottom: "30px" }}>
      {/* Item name above the loading bar */}
      <Col xs="4" className="d-flex  justify-content-start ps-3">
        <div
          style={{
            fontSize: isSub ? "16px" : "18px",
            fontWeight: "600",
            color: rgbEnabled ? (!isSub ? colors.dark : colors.primary) : "#333",
            textTransform: "uppercase",
            textAlign: "left",
          }}
        >
          {item.name}
        </div>
      </Col>

      <Col xs="8">
        <div style={{ display: "flex", alignItems: "center", gap: "10px", float: "right" }}>
          {/* Percentage text */}
          <div
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: rgbEnabled ? colors.dark : "#333",
              minWidth: "45px",
            }}
          >
            {elementScore}%
          </div>

          {/* Loading bar */}
          <div
            style={{
              width: "470px",
              height: "27px",
              backgroundColor: backgroundColor,
              borderRadius: "14px",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <div
              style={{
                height: "100%",
                width: `${elementScore}%`,
                backgroundColor: progressColor,
                borderRadius: "14px",
                transition: "width 0.3s ease",
              }}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
}
